var cov_21ozvbkih4 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/component.tsx",
      hash = "0fb012acdc30659219e11fca7ded39416da00200",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/component.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 39
        },
        end: {
          line: 4,
          column: 50
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "2": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 28
        }
      },
      "3": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "4": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 69
        }
      },
      "5": {
        start: {
          line: 19,
          column: 37
        },
        end: {
          line: 19,
          column: 69
        }
      },
      "6": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 55
        }
      },
      "7": {
        start: {
          line: 23,
          column: 36
        },
        end: {
          line: 23,
          column: 55
        }
      },
      "8": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "9": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 70
        }
      },
      "10": {
        start: {
          line: 25,
          column: 35
        },
        end: {
          line: 25,
          column: 70
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 71
        }
      },
      "12": {
        start: {
          line: 32,
          column: 25
        },
        end: {
          line: 32,
          column: 44
        }
      },
      "13": {
        start: {
          line: 33,
          column: 29
        },
        end: {
          line: 33,
          column: 52
        }
      }
    },
    fnMap: {
      "0": {
        name: "create",
        decl: {
          start: {
            line: 3,
            column: 9
          },
          end: {
            line: 3,
            column: 15
          }
        },
        loc: {
          start: {
            line: 3,
            column: 53
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        loc: {
          start: {
            line: 10,
            column: 24
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        loc: {
          start: {
            line: 18,
            column: 29
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 18
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        loc: {
          start: {
            line: 22,
            column: 18
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 69
          }
        }, {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 19,
            column: 69
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 55
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 23,
            column: 55
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }, {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 70
          }
        }, {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 70
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';

function create(name) {
  var _temp;

  cov_21ozvbkih4.f[0]++;
  var Base = (cov_21ozvbkih4.s[0]++, React[name]);
  cov_21ozvbkih4.s[1]++;
  return _temp =
  /*#__PURE__*/
  function (_Base) {
    _inherits(_temp, _Base);

    var _super = _createSuper2(_temp);

    function _temp() {
      var _this;

      _classCallCheck(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.$isMounted = void 0;
      _this.forceUpdateTimer = void 0;
      return _this;
    }

    _createClass(_temp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_21ozvbkih4.f[1]++;
        cov_21ozvbkih4.s[2]++;
        this.$isMounted = true;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_21ozvbkih4.f[2]++;
        cov_21ozvbkih4.s[3]++;
        this.$isMounted = false;
      }
    }, {
      key: "setState",
      value: function setState() {
        cov_21ozvbkih4.f[3]++;
        cov_21ozvbkih4.s[4]++;

        if (this.$isMounted !== false) {
          cov_21ozvbkih4.b[0][0]++;
          cov_21ozvbkih4.s[5]++;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          _get(_getPrototypeOf(_temp.prototype), "setState", this).apply(this, args);
        } else {
          cov_21ozvbkih4.b[0][1]++;
        }
      }
    }, {
      key: "forceUpdate",
      value: function forceUpdate() {
        cov_21ozvbkih4.f[4]++;
        cov_21ozvbkih4.s[6]++;

        if (this.$isMounted === true) {
          cov_21ozvbkih4.b[1][0]++;
          cov_21ozvbkih4.s[7]++;

          _get(_getPrototypeOf(_temp.prototype), "forceUpdate", this).call(this);
        } else {
          cov_21ozvbkih4.b[1][1]++;
        }

        cov_21ozvbkih4.s[8]++;

        if (this.$isMounted === undefined) {
          cov_21ozvbkih4.b[2][0]++;
          cov_21ozvbkih4.s[9]++;

          if (this.forceUpdateTimer) {
            cov_21ozvbkih4.b[3][0]++;
            cov_21ozvbkih4.s[10]++;
            clearTimeout(this.forceUpdateTimer);
          } else {
            cov_21ozvbkih4.b[3][1]++;
          }

          cov_21ozvbkih4.s[11]++;
          this.forceUpdateTimer = setTimeout(this.forceUpdate.bind(this));
        } else {
          cov_21ozvbkih4.b[2][1]++;
        }
      }
    }]);

    return _temp;
  }(Base), _temp;
}

export var Component = (cov_21ozvbkih4.s[12]++, create('Component'));
export var PureComponent = (cov_21ozvbkih4.s[13]++, create('PureComponent'));